<app-dialog [size]="dialogSize">
  <app-dialog-header (close)="cancel()">
    @if (isLoading()) {
      <h2>&nbsp;</h2>
    } @else if (!canReverse()) {
      <h2>Unable to Reverse Invoice</h2>
    } @else {
      <h2>Reverse Invoice</h2>
    }
  </app-dialog-header>

  <!-- Loading State -->
  @if (isLoading()) {
    <div class="d-flex justify-content-center align-items-center py-5">
      <mat-spinner diameter="40" />
    </div>
  }

  <!-- Can Reverse View -->
  @if (!isLoading() && canReverse()) {
    <div class="w-100">
      <form class="d-flex flex-column gap-4" [formGroup]="reversalForm">
        <!-- Information Message -->
        <p class="text-muted">
          When Invoices are reversed, the original Draft Invoice is restored and its creator will be notified to take action on it.
        </p>

        <!-- Reversal Reason Field -->
        <div class="d-flex flex-column gap-2">
          <label class="form-label" for="reversal-reason">
            Reversal Reason
            <span class="text-muted ms-1">(Optional)</span>
          </label>
          <textarea
            id="reversal-reason"
            dataSelector="invoice-reversal-dialog-reason-input"
            aria-label="Reversal reason"
            class="form-input w-100"
            formControlName="reason"
            inputErrorMessage="Reversal reason cannot exceed 512 characters"
            maxlength="512"
            placeholder="Type your comments and reason for reversal"
            rows="4"
            style="resize: none"
          ></textarea>
        </div>
      </form>
    </div>
  }

  <!-- Cannot Reverse View (conflicting draft invoices) -->
  @if (!isLoading() && !canReverse()) {
    <div class="w-100">
      <p class="conflict-message text-center mb-3">
        Projects used in this invoice have unsent Draft Invoices that were created since this invoice was sent. Please send or delete these
        new invoices before reversing this one.
      </p>

      <div class="pt-1">
        @for (invoice of conflictingDraftInvoices(); track invoice.draftInvoiceId + '-' + invoice.projectId) {
          <div class="d-flex align-items-start mb-2 gap-2">
            <anduin-icon name="share" class="invoice-icon flex-shrink-0 mt-1" size="sm" />
            <div class="invoice-text flex-1">
              <span class="flex-shrink-0">Unsent&nbsp;</span>
              <button
                dataSelector="invoice-reversal-dialog-draft-invoice-link"
                type="button"
                class="invoice-link btn btn-link p-0 border-0"
                [attr.title]="'Draft Invoice ' + invoice.draftInvoiceId"
                (click)="openDraftInvoice(invoice.draftInvoiceId)"
              >
                Draft Invoice {{ invoice.draftInvoiceId }}
              </button>
              <span class="flex-shrink-0">&nbsp;for project&nbsp;</span>
              <button
                dataSelector="invoice-reversal-dialog-project-link"
                type="button"
                class="project-link btn btn-link p-0 border-0"
                [attr.title]="invoice.projectName"
                (click)="openProject(invoice.projectId)"
              >
                {{ invoice.projectName }}
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  }

  <!-- Dialog Footer for Cannot Reverse state -->
  @if (!isLoading() && !canReverse()) {
    <app-dialog-footer [showCancel]="false">
      <div class="w-100">
        <button
          dataSelector="invoice-reversal-dialog-okay-button"
          type="button"
          class="w-100"
          (click)="cancel()"
          andButton
          cdkFocusInitial
          color="primary"
        >
          Okay
        </button>
      </div>
    </app-dialog-footer>
  }

  <!-- Dialog Footer - Only show for canReverse state -->
  @if (!isLoading() && canReverse()) {
    <app-dialog-footer [emitCloseEvent]="true" [showCancel]="true" (closeDialog)="cancel()">
      <button
        dataSelector="invoice-reversal-dialog-confirm-button"
        type="submit"
        [disabled]="isSubmitting() || reversalForm.invalid"
        [isLoading]="isSubmitting()"
        (click)="confirmReversal()"
        andButton
        color="primary"
      >
        Confirm Reversal
      </button>
    </app-dialog-footer>
  }
</app-dialog>
